import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { AuthenticationState } from "react-aad-msal";
import { getLoyaltyStorage } from "../../util";
import { LoyaltyAccountStatus } from "../../util/LoyaltyAccountStatus";
import Modal from "../modal/Modal";
import PausedAccountModule from "./PausedAccountModule";

var PausedAccountModal = function PausedAccountModal(props) {
  var authenticationState = props.authenticationState;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  useEffect(function () {
    var loyaltyStorage = getLoyaltyStorage();
    window.addEventListener("openPegPausedModal", function (e) {
      var _e$detail;

      if ((e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.show) === true) {
        setIsOpen(true);
      }
    });
    return function () {
      window.removeEventListener("openPegPausedModal", function () {});
    };
  }, []);

  var handleHide = function handleHide() {
    setIsOpen(false);
  };

  return /*#__PURE__*/React.createElement(Modal, {
    className: "loyalty-modal paused-account-modal",
    show: isOpen,
    hide: handleHide,
    hideCloseButton: true,
    backdrop: true
  }, /*#__PURE__*/React.createElement(PausedAccountModule, {
    model: props === null || props === void 0 ? void 0 : props.model
  }));
};

export default PausedAccountModal;